var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.343,
    height: 90.72,
    viewBox: "0 0 202.343 90.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(-140 -33.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M57.6,77.087V98.535H50.181V79.111c0-5.261-3.1-8.431-8.161-8.431-5.868.2-9.443,4.721-9.443,10.724V98.468H25.158V79.111c0-5.261-3.035-8.431-8.094-8.431-5.935.2-9.578,4.721-9.578,10.724V98.468H0V64.07H7.352v6.677C9.78,65.891,14.164,63.8,19.83,63.8c6.138,0,10.387,3.035,12.006,8.3,2.226-5.733,6.812-8.3,13.085-8.3,7.959,0,12.68,5.059,12.68,13.287",
    transform: "translate(140 12.58)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M160.514,77.087V98.535H153.1V79.111c0-5.193-3.1-8.363-8.3-8.363-5.733.067-9.24,4.047-9.78,9.375V98.468H127.6V64.07h7.419v6.61c2.5-4.789,6.88-6.88,12.68-6.88,8.026,0,12.815,5.059,12.815,13.287",
    transform: "translate(98.463 12.58)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M222.384,92.09h-7.419V86.222c-2.5,4.047-6.61,6.205-12.141,6.205-9.915,0-16.525-7.217-16.525-17.671,0-10.387,6.677-17.4,16.39-17.4,5.531,0,9.712,2.293,12.275,6.273V44h7.419Zm-7.419-17.132c0-6.677-4.317-11.331-10.589-11.331s-10.589,4.721-10.589,11.331c.067,6.542,4.317,11.2,10.589,11.2s10.589-4.654,10.589-11.2",
    transform: "translate(79.355 19.025)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M267.357,103.387c-2.158,5.463-6,8.161-11.2,8.161a11.5,11.5,0,0,1-7.959-2.9l3.17-5.733a7.364,7.364,0,0,0,4.452,1.686c2.293,0,4.047-1.214,5.261-3.845l1.147-2.563L248,64.2h7.689l10.32,26.1,9.645-26.1h7.419Z",
    transform: "translate(59.27 12.45)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M103.653,43.65a4.852,4.852,0,0,0,4.856-4.721v-.27a4.86,4.86,0,1,0-9.712,0,4.81,4.81,0,0,0,4.586,4.991h.27",
    transform: "translate(107.841 22.411)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M99.9,61.7V97.784h7.756V72.829c-1.214-5.4-3.575-8.633-7.756-11.129",
    transform: "translate(107.48 13.264)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M132.857,39.654c-2.158,5.463-6,8.161-11.2,8.161a11.5,11.5,0,0,1-7.959-2.9l3.17-5.733a7.364,7.364,0,0,0,4.452,1.686c2.293,0,4.114-1.214,5.261-3.845a6.611,6.611,0,0,0,.067-5.193L113.5.4h7.689l10.319,26.1L141.086.4h7.419Z",
    transform: "translate(103.053 33.218)",
    fill: "#f79041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M200.421,20.337H174.387A10.421,10.421,0,0,0,185.043,28.9a13.246,13.246,0,0,0,9.712-4.047l3.979,4.182c-3.372,3.71-8.3,5.8-14.231,5.8-10.589,0-17.6-7.082-17.6-17.4S174.117-.033,184.3-.1c12.073.135,17,8.026,16.12,20.437m-6.475-5.4c-.27-5.531-3.979-8.9-9.645-8.9-5.463,0-9.24,3.44-10.117,8.971h19.762Z",
    transform: "translate(85.67 33.381)",
    fill: "#f79041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M249.939,3.507l-2.7,5.531A20.154,20.154,0,0,0,237.327,6c-2.9,0-5.059.944-5.059,3.44,0,6.34,18.346,2.9,18.278,15.445,0,7.082-6.273,10.252-13.22,10.252-5.059,0-10.454-1.686-13.827-4.789l2.63-5.328a18.839,18.839,0,0,0,11.534,4.249c3.17,0,5.666-1.079,5.666-3.71,0-7.082-18.143-3.1-18.076-15.58-.067-7.015,6-9.982,12.613-9.982a21.559,21.559,0,0,1,12.073,3.507",
    transform: "translate(67.245 33.348)",
    fill: "#f79041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M93.526,62.841c-.27-.674-.472-1.349-.674-2.023-.135-.337-.2-.674-.337-1.012a8.182,8.182,0,0,1-.337-.944c-.4-1.282-1.012-2.5-1.484-3.71a24.455,24.455,0,0,0-4.047-6.07c-3.237-3.372-7.554-5.463-12.41-7.891a68.119,68.119,0,0,1-7.487-4.182A25.16,25.16,0,0,1,60.072,30.6a18.586,18.586,0,0,1-3.3-8.7,6.545,6.545,0,0,1-.067-1.147V18.528a5.9,5.9,0,0,1,.135-1.079,19.057,19.057,0,0,1,.877-4.249c.472,1.349.877,2.7,1.349,3.979a5.286,5.286,0,0,1,.337.944c.135.337.27.607.4.944.27.607.54,1.214.809,1.754a18.491,18.491,0,0,0,1.956,3.1,4.726,4.726,0,0,1,.54.674c.067.135.2.2.27.337l.337.337c.4.4.809.877,1.214,1.214A31.006,31.006,0,0,0,70.8,30.467c2.158,1.214,4.586,2.293,7.082,3.507a52.156,52.156,0,0,1,7.487,4.452,24.006,24.006,0,0,1,6.408,6.88,20.645,20.645,0,0,1,2.833,8.836,24.542,24.542,0,0,1-.067,4.452c-.067.337-.067.742-.135,1.079s-.135.742-.2,1.079a14.943,14.943,0,0,0-.674,2.091",
    transform: "translate(121.543 29.052)",
    fill: "#f79041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M75.4,24.705A6.205,6.205,0,1,0,81.605,18.5h0A6.232,6.232,0,0,0,75.4,24.705h0",
    transform: "translate(115.456 27.326)",
    fill: "#f79041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindyLogo);
export default __webpack_public_path__ + "static/media/mindy-logo.98fc6b030c898655b5a4717a85f1c4ad.svg";
export { ForwardRef as ReactComponent };